import { useLanguage } from '../../contexts/language';
import { usePatients } from '../../hooks/patients';

import { BackLink } from '../back-link';
import { InviteForm } from '../invite-form';
import { LoadFailed } from '../load-failed';
import { SentInvitation } from '../sent-invitation';

import styles from './style.module.css';

// Invite patient, as drawn in the blueprint: the form, then the invitations
// already sent that wait for an answer, each with Resend and Withdraw, and
// those the patient declined. The list is read again after every change, so
// it shows what the server now holds.
export function InvitePatient() {
  const { text } = useLanguage();
  const { data, error, retry, reload } = usePatients();

  let sent = null;

  if (error != null) {
    sent = <LoadFailed onRetry={ retry }/>;
  }

  if (data !== undefined && data.sentInvitations.length > 0) {
    const rows = data.sentInvitations.map(function(invitation) {
      return <SentInvitation key={ invitation.id } invitation={ invitation } onChange={ reload }/>;
    });

    sent = (
      <section className={ styles.sent } aria-labelledby='sent-invitations'>
        <h2 id='sent-invitations' className={ styles.heading }>{ text.pending }</h2>

        <div className={ styles.list }>{ rows }</div>
      </section>
    );
  }

  return (
    <section className={ styles.page }>
      <BackLink to='/patients'>{ text.patients }</BackLink>

      <h1 className={ styles.title }>{ text.invitePatientTitle }</h1>

      <InviteForm onSent={ reload }/>

      { sent }
    </section>
  );
}
